import { heroMini } from "@/mocks/kanliao";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-4 h-56 w-56 rounded-full bg-accent-200/50 blur-3xl" />

      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.25fr_0.75fr] lg:py-20">
        <div className="fade-rise relative">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            今日 5看料 正在同步更新中
          </span>
          <h1 className="mt-5 font-heading text-4xl font-black leading-[1.12] text-foreground-950 md:text-5xl lg:text-[64px]">
            蹲料更新不迷路，
            <br />
            热门新料<span className="text-primary-600">抢先看</span>。
          </h1>
          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-foreground-700 md:text-base">
            5看料 全网聚合最新爆料与速递，正主动态、赛果进度、行程路透一网打尽。
            不用东奔西跑，追更 5看料 更新，第一时间拿到高能瞬间。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#scoop"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              进入料场，先蹲爆料
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#peek"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-200"
            >
              <i className="ri-arrow-down-circle-fill text-accent-600" />
              下载 App，消息不漏
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-background-200 pt-5">
            <div className="flex items-center gap-2">
              <strong className="font-heading text-2xl font-black text-primary-600">328</strong>
              <span className="text-xs text-foreground-600">个话题在追更</span>
            </div>
            <div className="flex items-center gap-2">
              <strong className="font-heading text-2xl font-black text-accent-600">1.2万+</strong>
              <span className="text-xs text-foreground-600">条爆料速递同步</span>
            </div>
            <div className="flex items-center gap-2">
              <strong className="font-heading text-2xl font-black text-foreground-950">24h</strong>
              <span className="text-xs text-foreground-600">高能不眠蹲</span>
            </div>
          </div>
        </div>

        <div className="fade-rise relative hidden lg:block">
          <div className="rounded-lg border border-background-200 bg-background-100/70 p-4">
            <div className="mb-3 flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-fire-line text-accent-600" />
                今日蹲料热榜
              </h2>
              <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
                LIVE
              </span>
            </div>
            <ul className="space-y-2">
              {heroMini.map((m, idx) => (
                <li
                  key={m.name}
                  className="flex items-center gap-3 rounded-md bg-background-50 px-3 py-2.5"
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                    {idx + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-950">{m.name}</p>
                    <p className="text-[11px] text-foreground-500">{m.state} · 热度 {m.hot}</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
                </li>
              ))}
            </ul>
            <div className="float-soft mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-2 text-xs font-semibold text-background-50">
              <i className="ri-lightbulb-flash-fill" />
              上线 1 小时，热度已超昨日峰值
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}